import { render, staticRenderFns } from "./editDesign.vue?vue&type=template&id=485d8e56&"
import script from "./editDesign.vue?vue&type=script&lang=ts&"
export * from "./editDesign.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports